import { useState, useEffect, useRef } from "react";

// Componente para animar números estilo caça-níquel
const AnimatedNumber = ({ value, className = "" }) => {
    const [displayValue, setDisplayValue] = useState(value);
    const [isAnimating, setIsAnimating] = useState(false);
    const prevValueRef = useRef(value);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (prevValueRef.current !== value) {
            const oldValue = prevValueRef.current;
            const newValue = value;
            const difference = Math.abs(newValue - oldValue);

            setIsAnimating(true);

            // Limpar timeout anterior se existir
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Para mudanças pequenas, animar diretamente
            // Para mudanças grandes, mostrar valores intermediários
            if (difference <= 1) {
                // Mudança pequena: animação simples
                setDisplayValue(newValue);
                timeoutRef.current = setTimeout(() => {
                    setIsAnimating(false);
                    prevValueRef.current = newValue;
                }, 300);
            } else {
                // Mudança grande: efeito de rolagem com valores intermediários
                const steps = Math.min(difference, 8); // Máximo 8 passos
                const stepDuration = 250 / steps;
                let currentStep = 0;

                const animate = () => {
                    if (currentStep < steps) {
                        const progress = (currentStep + 1) / steps;
                        // Usar easing para suavizar a transição
                        const easedProgress = progress < 0.5
                            ? 2 * progress * progress
                            : 1 - Math.pow(-2 * progress + 2, 2) / 2;

                        const intermediateValue = Math.round(oldValue + (newValue - oldValue) * easedProgress);
                        setDisplayValue(intermediateValue);
                        currentStep++;
                        timeoutRef.current = setTimeout(animate, stepDuration);
                    } else {
                        setDisplayValue(newValue);
                        setIsAnimating(false);
                        prevValueRef.current = newValue;
                    }
                };

                animate();
            }
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [value]);

    return (
        <span className={`animated-number ${isAnimating ? 'animating' : ''} ${className}`}>
            {displayValue}
        </span>
    );
};

export default AnimatedNumber;
